var _path;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgHome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.003 20h14c1.103 0 2-.897 2-2V9a.997.997 0 00-.293-.707l-8-8a.999.999 0 00-1.414 0l-8 8A.997.997 0 00.003 9v9c0 1.103.897 2 2 2zm5-2v-5h4v5h-4zm-5-8.586l7-7 7 7V18h-3v-5c0-1.103-.897-2-2-2h-4c-1.103 0-2 .897-2 2v5h-3V9.414z"
  })));
}

export default SvgHome;